export default {
    en: {
        id: 'exercise_1',
        diagram: `
          <div class="two-columns angular-ngAnimate 5a-exercise-1">
            <div ng-show="vm.activeIndex <= 1" class="first-step-text">
             <p style="margin:7px 0;" class="yellow-text">The first thing you need to do...</p>
            </div>
            <div>
              <div ng-show="vm.activeIndex >= 1" style="width: 440px;" class="step__diagram-content angular-ngAnimate" ng-style="{'background-image': vm.activeIndex === 1 ? 'url(\\'/assets/images/5a-1-step-1-bg.png\\')' : ''}">
                <div class="step__diagram-title">
                  <p>The first thing you need to do is identify the arena within which the problem is taking place.</p>
                  <p style="margin:7px 0;" class="yellow-text">Visualize the Situation</p>
                </div>
                <div style="padding: 0;" class="step__diagram-content small-white-text__list">
                  <p class="step__diagram-content-header" style="margin-bottom: 10px;">SITUATION (OPENING SCENE)</p>
                  <div class="step__diagram-step-1-table">
                    <img style="height: 180px; object-fit: contain;" src="/assets/images/5a-step1-diagram.png" alt="Original Structure">
                  </div>
                  <p style="margin-bottom: 10px; margin-top: 10px;" class="yellow-text">Let’s review what you know that is going on now in the company.</p>
                  <p class="small-white-text">We know the company’s name</p>
                  <p class="small-white-text">That it is large, with many divisions</p>
                  <p class="small-white-text">We know how much it spends annually on procurement ($600m)</p>
                  <p class="small-white-text">Amd that they purchase from hundreds of suppliers</p>
                  <p class="small-white-text">We know there is no centralized control over who buys what from whom</p>
                  <p class="small-white-text">And that the VP believes that supppliers are too much in control</p>
                  <p class="small-white-text">He also thinks Orlando may be paying too much, and getting poor service</p>
                  <p class="small-white-text">He naturally wants to pay fair price and receive preferential service</p>
                </div>
               </div>
            </div>

            <div style="padding-top: 66px;" class="second-column">
              <div style="display: flex">
                <div ng-show="vm.activeIndex >= 2" class="angular-ngAnimate" style="padding: 7px 0 0 7px" ng-style="{'background-image': vm.activeIndex <= 2 ? 'url(\\'/assets/images/5a-1-step-2-bg.png\\')' : ''}">
                  <div class="step__diagram-title">
                    <p style="margin-top: 6px; margin-left: 10px;" class="yellow-text">State what we don’t like about the Situation (R1)</p>
                  </div>
                  <div class="step__diagram-content" style=" align-items: center; padding: 15px 10px;">
                    <p class="step__diagram-content-header">R1</p>
                    <div class="step-3__box">
                      <p class="step-3__box-text">Risk that paying more, getting inferior service</p>
                    </div>
                  </div>
                </div>
                <div ng-show="vm.activeIndex >= 3" style="background-size: cover; padding: 7px 0 0 7px;" class="angular-ngAnimate" ng-style="{'background-image': vm.activeIndex <= 3 ? 'url(\\'/assets/images/5a-1-step-3-bg.png\\')' : ''}">
                  <div class="step__diagram-title">
                    <p style="margin-top: 6px; margin-left: 10px;" class="yellow-text">State what we want instead (R2)</p>
                  </div>
                  <div class="step__diagram-content"
                       style="align-items: center; padding: 15px 10px;">
                    <p class="step__diagram-content-header">R2</p>
                    <div class="step-3__box">
                      <p class="step-3__box-text">Highest quality products and services at lowest reasonable price</p>
                    </div>
                  </div>
                </div>
              </div>
              <div ng-show="vm.activeIndex >= 4" class="angular-ngAnimate" style="display: flex; flex-direction: column; align-items: center;">
                <svg height="150" width="300" style="margin-top: -18px; margin-bottom: -32px;">
                  <line x1="25" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>
                  <line x1="280" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>
                </svg>
                <div class="step__diagram-content" style="background-image: url('/assets/images/5a-1-step-4-bg.png'); align-items: center; background-size: cover; padding: 15px 10px; margin-top: 28px">
                  <p class="step__diagram-content-header">SOLUTION</p>
                  <div class="step-3__box" style="width: 217px">
                    <p class="step-3__box-text">Make sure company sources products and services only from qualified suppliers</p>
                  </div>
                  <div class="step__diagram-title">
                    <p style="max-width: initial; margin-top: 20px;" class="yellow-text">State how you will get from R1 to R2 (if you know it)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>`,
        steps: 4,
        startStep: 0,
      // note: 'Step 6 is not applicable here',
        pyramidData: {
          exerciseNumber: 1,
          scheme: 'empty',
          scq: {
            s: 'We do X in Y way now',
            c: 'Have a problem',
            q: 'What should we do?'
          },
          instruction: 'Now you have a very clear picture of the problem and its solution in your mind. You also have an indication of the question that document has to be structured to answer. You are ready to write. To do this please open the Minto Framework button below-right, as this is an example, we have pre-filled the SCQ boxes with the school solution for you this time.',
          tourData: {
            steps: [
              {
                element: 'pyramid-step-1',
                text: 'Adjust Scale and Opacity depend on your needs',
              },
              {
                element: 'pyramid-step-2',
                text: 'Use Scroll to navigate thru Exercise layer',
                direction: 'top',
              },
              {
                element: 'pyramid-step-3',
                text: 'Fill in the text for SCQ',
                direction: 'bottom',
              },
              {
                element: 'pyramid-step-4',
                text: 'After you\'re done, press Submit button to continue the exercise',
                direction: 'top',
              },
            ],
          },
        },
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5a/defineProblem/i18n/exercise1.js